import { UseFieldConfig } from 'react-final-form';
import ASelect, { SelectProps } from 'antd/lib/select';
import { FormControl, FormControlBaseProps } from '../FormControl';

import styles from './Select.module.scss';

type Props = FormControlBaseProps &
  UseFieldConfig<string> &
  Omit<SelectProps, 'value' | 'onChange'>;

function SelectBase(props: SelectProps) {
  return (
    <div className={styles.select}>
      <ASelect {...props} bordered={false} />
    </div>
  );
}

function SelectControl({
  className,
  label,
  placeholder,
  noHint,
  hint,
  name,
  ...props
}: Props) {
  return (
    <FormControl<string>
      label={label}
      className={className}
      required={props.required}
      name={name}
      hint={hint}
      {...props}
    >
      {({ floating, readOnly, ...controlProps }) => (
        <SelectBase
          {...props}
          {...controlProps}
          placeholder={floating ? placeholder : undefined}
          disabled={props.disabled || readOnly}
        />
      )}
    </FormControl>
  );
}

export const Select = Object.assign(SelectControl, {
  Base: SelectBase
});
